<template>
  <DefaultLayout>
    <!--Header -->
    <div v-if="collection && authorizedUser">
      <div v-if="this.$route.name =='network_collection'" class="d-lg-none d-xl-none" :style="{'margin-top': this.$route.name =='network_collection' ? '-60px' : '-10px'}"></div>
      <div v-if="this.$route.name =='network_collection'" class="d-none d-xxl-block" style="margin-top: 115px;"></div>
      <div class="row mb-n4">
        <div class="navbar navbar-expand-lg">
          <!-- Breadcrumbs -->
          <div class="col-10">
            <nav aria-label="breadcrumb">
              <ol v-if="!busy" class="pt-1 breadcrumb align-middle">
                <li class="breadcrumb-item">
                  <a :href="network ? '/networks/' + network.slug : '/media'" class="text-primary fw-bold">
                    {{ network ? network.name : $t('network.AllMedia') }}
                  </a>
                </li>
                <li v-if="network" class="breadcrumb-item">
                  <a :href="'/networks/' + network.slug + '/media'" class="text-primary fw-bold">
                    {{ $t('nav.media') }}
                  </a>
                </li>
              </ol>
            </nav>
          </div>
          <div class="toolbar d-flex justify-content-end order-lg-3 ms-lg-auto col-2">
            <a v-if="collection.can_download" id="download_collection" data-test="download_collection"
            class="text-primary fw-bold pointer text-decoration-none"
            style="padding: 0.425rem 0.5rem !important" @click="downloadCollection()">
              <i class="fa fa-download"></i>&nbsp;
              {{ $t('network.download') }}
            </a>
            <div class="navbar-tool dropdown">
              <a href="#" class="navbar-tool-label dropdown-toggle border rounded-3 border-0 user-dropdown ms-4 me-2 d-flex"
              data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa-solid fa-ellipsis-vertical fs-3"></i>
              </a>
              <ul class="dropdown-menu dropdown-menu-end pointer" style="top: 100%;">
                <li>
                  <Fav :loading="loading" :media="true" :value="is_liked" @input="toggleLike" />
                </li>
                <li>
                  <a class="dropdown-item d-flex align-items-center text-decoration-none" @click="showShareModal = !showShareModal">
                    <i class="fas fa-share text-primary"></i>&nbsp;
                    {{ $t('share') }}
                  </a>
                </li>
                <li v-if="collection.can.update">
                  <span class="dropdown-item d-flex align-items-center text-decoration-none" @click="goToEditForm">
                    <i class="fas fa-edit text-primary"></i>&nbsp;
                    {{ $t('edit') }}
                  </span>
                </li>
                <li v-if="collection.can.delete">
                  <a class="dropdown-item d-flex align-items-center text-decoration-none" @click="showDeleteConfirmModal">
                    <i class="fas fa-trash text-danger"></i>&nbsp;
                    {{ $t('network.delete') }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-items-center" style="margin-top: 16px;">
          <h4 class="text-secondary ms-2">{{ collection.title }}</h4>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-items-center border-left">
          <div v-if="collection.creator" class="mx-3">
            <div class="avatar-group">
              <div class="avatar">
                <img :src="collection.creator_img ? collection.creator_img : '/img/user.png'" class="avatar-img rounded-circle" />
              </div>
            </div>
            <span class="mx-1 my-lg-2 fw-semibold">
              {{ $t('collection-curated-by') }} {{ collection.creator }}
            </span>
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-items-center border-left">
          <div style="display: flex; justify-content: space-evenly;">
            <span class="ms-2 mt-3">
              <i class="fas fa-calendar-day"></i>&nbsp;
              <strong v-if="collection.publish_date">{{ formatDate(collection.publish_date) }}</strong>
              <strong v-else>{{ $t('not-available') }}</strong>
            </span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <!-- /.header -->

    <div v-if="busy" class="text-center pt-7">
      <lottie-player
        autoplay
        loop
	      speed="2.5"
        src="/img/animations/custom_loader.json"
        style="height: 130px;"
        >
      </lottie-player>
      <p id="cancel-label">{{ $t('network.fetchingCollectionDetails') }}</p>
    </div>

    <div v-if="collection && authorizedUser">
      <OrganizedView v-if="collection.is_organized" :collection="collection" />
      <BasicView v-else :media="collection.media" />
    </div>
    <!--Footer-->
    <div v-if="collection && showFooter" class="row my-3">
      <hr>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 pb-3 d-flex justify-content-end">
        <div class="mx-2">
          <div v-if="collection.tags && collection.tags.length > 0">
              <button class="btn btn-outline-primary" style="height: 49px; border: 2px solid;" @click="showTagsModal = !showTagsModal">{{ $t('tags') }}</button>
          </div>
          <div v-else>
            <button class="btn text-secondary btn-sm m-2 fw-bold" style="background-color: #D9D9D9;">{{ $t('no-tags') }}</button>
          </div>
        </div>
        <div class="mx-2">
          <a v-if="collection.networks && collection.networks.length > 0" class="btn btn-primary" style="padding-left: 16px;" @click="showBelongsToNetworkModal = !showBelongsToNetworkModal">
            <svg width="27" height="29" viewBox="3 1 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24.1482 11.2933C25.2965 11.2933 26.2274 10.3624 26.2274 9.21415C26.2274 8.06587 25.2965 7.13501 24.1482 7.13501C23 7.13501 22.0691 8.06587 22.0691 9.21415C22.0691 10.3624 23 11.2933 24.1482 11.2933Z"
                fill="white"
              />
              <path
                d="M22.4202 18.6378C22.0151 18.6378 21.6371 18.7458 21.2861 18.9889C21.3401 18.9619 21.3671 18.9349 21.4211 18.9078L19.0989 17.5038C19.2609 17.0177 19.3419 16.5317 19.3419 16.0187C19.3419 15.3976 19.2069 14.7766 18.9639 14.2095L18.9369 14.1555L21.1241 12.6974C21.6101 12.3734 21.7451 11.7254 21.4481 11.2393V11.2123C21.1241 10.7263 20.476 10.5913 19.99 10.9153L17.6948 12.4544C16.8578 11.7524 15.8047 11.3473 14.7246 11.3473C14.4006 11.3473 14.0766 11.4013 13.7526 11.4823L12.8075 9.4572C12.7535 9.5382 12.6725 9.61921 12.5915 9.70021C13.4015 8.86316 13.4015 7.54006 12.5645 6.70301C11.7274 5.86595 10.3233 5.91995 9.51327 6.75701C8.70321 7.59407 8.70321 8.91716 9.54027 9.75422C10.0263 10.2403 10.7283 10.4563 11.4304 10.3213C11.2954 10.3483 11.1874 10.3483 11.0524 10.3483C10.9984 10.3483 10.9444 10.3483 10.8634 10.3483L11.8084 12.3734C10.9714 13.0214 10.1343 14.5605 10.1343 16.0457C10.1343 19.1779 12.4565 20.717 14.6706 20.717C15.9397 20.717 17.1548 20.2039 18.0189 19.2859L20.341 20.69C20.341 20.582 20.368 20.447 20.368 20.3389C20.341 20.474 20.341 20.582 20.341 20.717C20.341 21.8511 21.2591 22.7961 22.4202 22.7961C23.5812 22.7961 24.4993 21.8781 24.4993 20.717C24.4993 19.5559 23.5812 18.6378 22.4202 18.6378ZM11.4844 10.2943C11.5924 10.2673 11.7274 10.2403 11.8354 10.1862C11.7274 10.2403 11.6194 10.2943 11.4844 10.2943ZM12.4835 9.78122C12.4025 9.86222 12.3215 9.94323 12.2135 9.99723C12.2945 9.94323 12.4025 9.86222 12.4835 9.78122ZM12.1865 10.0242C12.0784 10.0782 11.9974 10.1322 11.8894 10.1862C11.9974 10.1322 12.0784 10.0782 12.1865 10.0242ZM14.6706 18.6378C13.2395 18.6378 12.0514 17.4768 12.0514 16.0457C12.0514 14.6146 13.2125 13.4265 14.6436 13.4265C16.0747 13.4265 17.2628 14.5876 17.2628 16.0187C17.2628 17.4497 16.1017 18.6108 14.6706 18.6378ZM21.2591 19.0159C21.1511 19.0969 21.0701 19.1779 20.9621 19.2589C21.0701 19.1509 21.1511 19.0699 21.2591 19.0159ZM20.503 19.9339C20.476 20.0419 20.422 20.1499 20.395 20.2579C20.449 20.1499 20.476 20.0419 20.503 19.9339ZM20.9621 19.2589C20.8811 19.3399 20.8 19.4209 20.746 19.5289C20.8 19.4209 20.8811 19.3399 20.9621 19.2589ZM20.692 19.5829C20.638 19.6909 20.557 19.7989 20.53 19.9069C20.584 19.7719 20.638 19.6639 20.692 19.5829Z"
                fill="white"
              />
              <path
                d="M8.80878 16.5586C8.80878 16.0186 8.51176 15.5595 8.16074 15.5865L6.40562 15.6135C5.83858 14.6955 4.65049 14.3985 3.73243 14.9385C2.81437 15.4785 2.51735 16.6936 3.05738 17.6117C3.59742 18.5297 4.81251 18.8268 5.73057 18.2867C6.02759 18.1247 6.2436 17.8817 6.40562 17.5847L8.18774 17.5577C8.51176 17.5577 8.80878 17.1256 8.80878 16.5586Z"
                fill="white"
              />
            </svg>
            <span v-if="collection.networks.length == 1">
              {{ $t('Available-in-network') }}
            </span>
            <span v-else>
              {{ $t('Available-in-networks', { num: collection.networks.length }) }}
            </span>
          </a>
          <div class="d-lg-none d-xl-block d-xl-none mt-2"></div>
        </div>
      </div>
      <hr>
    </div>

    <ConfirmModalWithInput
      v-if="collection"
      :placeholder="$t('Showtype-delete-to-proceed')"
      :showModal="confirmModal.show"
      :confirmationText="$t('network.delete').toUpperCase()"
      :okTitle="$t('Create.proceed')"
      @input-modal-confirmed="deleteCollection"
      @input-modal-cancel="confirmModal.show = false"
    >
      {{ confirmModalText }}
    </ConfirmModalWithInput>

    <JoinNetworkCard :show="showJoinCard" :network="network" :instance="instance" />

    <b-modal v-model="showShareModal" hide-footer hide-header no-stacking>
      <div class="text-center">
        <span>{{ $t('share-this-collection-to-your-choice-of-social-media-or-contacts') }}</span><br /><br />
        <a class="pointer" @click="accessShareLink('Facebook', facebook+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#475993;" d="M353.701,0H55.087C24.665,0,0.002,24.662,0.002,55.085v298.616c0,30.423,24.662,55.085,55.085,55.085
            h147.275l0.251-146.078h-37.951c-4.932,0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959,3.996-8.989,8.955-8.989h37.882
            v-45.498c0-52.8,32.247-81.55,79.348-81.55h38.65c4.945,0,8.955,4.009,8.955,8.955v39.704c0,4.944-4.007,8.952-8.95,8.955
            l-23.719,0.011c-25.615,0-30.575,12.172-30.575,30.035v39.389h56.285c5.363,0,9.524,4.683,8.892,10.009l-5.581,47.087
            c-0.534,4.506-4.355,7.901-8.892,7.901h-50.453l-0.251,146.078h87.631c30.422,0,55.084-24.662,55.084-55.084V55.085
            C408.786,24.662,384.124,0,353.701,0z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('WhatsApp', whatsapp+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#7AD06D;" d="M198.929,0.242C88.5,5.5,1.356,97.466,1.691,208.02c0.102,33.672,8.231,65.454,22.571,93.536
              L2.245,408.429c-1.191,5.781,4.023,10.843,9.766,9.483l104.723-24.811c26.905,13.402,57.125,21.143,89.108,21.631
              c112.869,1.724,206.982-87.897,210.5-200.724C420.113,93.065,320.295-5.538,198.929,0.242z M323.886,322.197
              c-30.669,30.669-71.446,47.559-114.818,47.559c-25.396,0-49.71-5.698-72.269-16.935l-14.584-7.265l-64.206,15.212l13.515-65.607
              l-7.185-14.07c-11.711-22.935-17.649-47.736-17.649-73.713c0-43.373,16.89-84.149,47.559-114.819
              c30.395-30.395,71.837-47.56,114.822-47.56C252.443,45,293.218,61.89,323.887,92.558c30.669,30.669,47.559,71.445,47.56,114.817
              C371.446,250.361,354.281,291.803,323.886,322.197z"/>
            <path style="fill:#7AD06D;" d="M309.712,252.351l-40.169-11.534c-5.281-1.516-10.968-0.018-14.816,3.903l-9.823,10.008
              c-4.142,4.22-10.427,5.576-15.909,3.358c-19.002-7.69-58.974-43.23-69.182-61.007c-2.945-5.128-2.458-11.539,1.158-16.218
              l8.576-11.095c3.36-4.347,4.069-10.185,1.847-15.21l-16.9-38.223c-4.048-9.155-15.747-11.82-23.39-5.356
              c-11.211,9.482-24.513,23.891-26.13,39.854c-2.851,28.144,9.219,63.622,54.862,106.222c52.73,49.215,94.956,55.717,122.449,49.057
              c15.594-3.777,28.056-18.919,35.921-31.317C323.568,266.34,319.334,255.114,309.712,252.351z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('LinkedIn', linkedin+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 10px;" xml:space="preserve">
            <path style="fill:#0077B7;" d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
            C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
            H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
            c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
            s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
            c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
            c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
            c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
            L341.91,330.654L341.91,330.654z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('Twitter', twitter+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="55" height="55" viewBox="0 0 1668.56 1221.19" style="enable-background:new 0 0 1668.56 1221.19; margin-right: 10px;" xml:space="preserve">
          <g id="layer1" transform="translate(52.390088,-25.058597)">
            <path id="path1009" d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
              h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"/>
          </g>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('Email', email+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve">
            <circle style="fill:#267CB5;" cx="64" cy="64" r="64"/>
            <path style="fill:#FFFFFF;" d="M64,28"/>
            <path style="fill:#FFFFFF;" d="M64,72.4l38.2-32.7c-0.6-0.4-1.4-0.7-2.2-0.7H28c-0.8,0-1.6,0.3-2.2,0.7L64,72.4z"/>
            <path style="fill:#FFFFFF;" d="M66.6,75.4c-1.5,1.3-3.7,1.3-5.2,0L24,43.5V85c0,2.2,1.8,4,4,4h72c2.2,0,4-1.8,4-4V43.4L66.6,75.4z"/>
          </svg>
        </a>
      </div>
      <div class="form-control align-items-center sharing">
        <span class="url-field">{{ home + '/...' }}</span>
        <div style="float: right;">
          <span class="btn btn-primary btn-sm text-white copy-btn" @click.prevent="copyUrl">
            <span style="text-transform: capitalize; margin-bottom: -1px;">{{ $t('Invite.copy') }}</span>
          </span>
        </div>
        <input id="url" data-test="url" :value="home+viewUrl" type="hidden">
      </div>
      <span id="copied">{{ $t('Invite.copied') }}</span>
    </b-modal>
    <b-modal v-model="showPrivateCollectionModal" hide-footer hide-header>
      <div class="text-center py-4">
        <h5 class="text-secondary mb-4">
          You're not authorized to see this content. If you have any questions, please contact the support team.
        </h5>
        <a href="#" class="btn btn-primary btn-md" @click="contactNow">{{ $t('Contact.click-here-to-contact-us') }}</a>
      </div>
    </b-modal>
    <b-modal v-if="collection && collection.networks" v-model="showBelongsToNetworkModal" hide-footer hide-header size="lg">
      <BelongsToNetwork :networksList="collection.networks" @belongsToNetworkSuccess="showBelongsToNetworkModal = false" @close="showBelongsToNetworkModal = false" />
    </b-modal>
    <Modal v-if="collection && collection.tags" :show.sync="showTagsModal" :hideHeader="false" title="Collection tags">
      <div>
        <span v-for="tag in collection.tags" :key="tag.id">
          <span class="badge m-2 media-badge">#{{ tag.name }}</span>
        </span>
      </div>
    </Modal>
  </DefaultLayout>
</template>
<script>
import OrganizedView from './views/OrganizedView.vue';
import BasicView from './views/BasicView.vue';
import ConfirmModalWithInput from '@/components/commons/Modals/ConfirmModalWithInput.vue';
import JoinNetworkCard from '@/components/commons/Networks/JoinNetworkCard.vue';
import Modal from '@/components/commons/Modals/Modal.vue';
import BelongsToNetwork from '../BelongsToNetwork.vue';
import Fav from '@/components/Fav.vue';
import { durationForHumans } from '@/lib/util.js';
import moment from 'moment';
import split from 'lodash/split';
import { mapState } from 'vuex';

export default {
  components: {
    BasicView,
    ConfirmModalWithInput,
    JoinNetworkCard,
    Modal,
    BelongsToNetwork,
    OrganizedView,
    Fav,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    collection_slug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      busy: true,
      loading: false,
      collection: null,
      confirmModal: {
        show: false,
      },
      network: null,
      authorizedUser: false,
      home: window.location.origin,
      facebook: 'https://www.facebook.com/share.php?u=',
      whatsapp: 'https://wa.me/?text=',
      linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=',
      twitter: 'https://twitter.com/share?ref_src=twsrc%5Etfw&url=',
      email: 'mailto:?subject=Resonance collection&amp;body=Check out this collection ',
      showShareModal: false,
      is_liked: '',
      video_counter: 0,
      showPrivateCollectionModal: false,
      showBelongsToNetworkModal: false,
      showTagsModal: false,
      showJoinCard: false,
      showFooter: false,
      instance: '',
    };
  },
  computed: {
    ...mapState('network', ['myNetworks']),
    totalMediaCount() {
      return this.$t('network.collection.mediaCount', {
        defaultValue: '{{ count }} ' + this.$t('network.items'),
        count: this.collection.media.length,
      });
    },
    mediaTags() {
      let temp = [];
      if (this.collection) {
        this.collection.media.forEach(m => {
          m.tags.forEach(tag => {
            if (!temp.find(tempTag => tempTag.id == tag.id)) {
              temp.push(tag);
            }
          });
        });
      }
      return temp;
    },
    confirmModalText() {
      let text = this.$t('are-you-sure-you-would-like-to-delete-this-collection-and-all-exclusively-associated-media-items');

      if (this.collection.networks.length > 1) {
        text += this.$t('Show.this-collection-is-part-of-following-networks-and-will-be-deleted-from-all-of-these') + this.collection.networks.map(n => n.name);
      }
      return text;
    },
    viewUrl() {
      let url = '/networks/';
      url += this.network ? this.network.slug + '/' : '';
      url += this.collection ? 'collections/' + this.collection.slug : '';
      return url;
    },
  },
  watch: {
    collection_slug(newV) {
      if (newV !== this.collection.slug) this.refresh();
    },
    showJoinCard(newVal) {
      if (newVal == true) {
        this.$store.dispatch('setNextURL', this.$route.fullPath);
      }
    },
  },
  mounted() {
    this.refresh();
    this.$bus.on('show-collection-footer', () => {
      this.showFooter = true;
    });
    this.$bus.on('hide-collection-footer', () => {
      this.showFooter = false;
    });
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY');
    },
    durationForHumans(seconds) {
      return durationForHumans(seconds);
    },
    // check the route parameter and the store, and refresh it if needed
    refresh() {
      if (this.collection == null || this.collection.slug !== this.collection_slug) {
        // refresh it!
        this.busy = true;
        if (!this.$auth.auth) {
          if (this.network) {
            this.instance = 'showLoggedOutModal';
            this.showJoinCard = true;
          } else {
            this.$bus.emit('show-sign-in', this.$route.fullPath, this.$t('auth.signInMessage.protectedMedia'));
          }
        } else {
          this.$http.get('networks/collections/' + this.collection_slug).then(resp => {
            this.collection = resp.data;
            this.is_liked = resp.data.is_liked;
            this.busy = false;
            // load network data if needed
            if (this.slug !== null && this.network === null) {
              this.busy = true;
              this.$http.get('networks/' + this.slug).then(resp => {
                this.network = resp.data;
                this.busy = false;

                // now that network data is loaded, call visitMedia
                if (this.collection !== null) {
                  this.visitMedia(this.collection);
                }
              });
            } else {
              // no network
              if (this.media !== null) {
                this.visitMedia(this.collection);
              }
            }
          }).catch(error => {
            // Check for 404 status manually and handle it
            if (error && error.status === 404) {
              // The resource was not found (invalid collection_slug)
              this.$router.push('/404');
            } else {
              // Other server response errors or network issues
              console.log('Error:', error.message);
            }
          });
        }
      }
    },
    accessShareLink(link_name, link) {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track(`share-${link_name.toLowerCase()}-collection-${this.collection.id}`);
      }
      let url = 'collections/' + this.collection.slug + '/' + this.$store.getters['user']['user_id'] + '/' + link_name;
      this.$http.post(url).then(() => {
        window.location.href = link;
      });
    },
    showDeleteConfirmModal() {
      this.confirmModal.show = true;
    },
    downloadCollection(){
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track(`download-collection-${this.collection.id}`);
      }
      this.collection.media.forEach(m => {
        if (m.type == 'video') {
          this.video_counter++;
        }
      });
      // if there are any videos as part of the collection, notify the user
      if (this.video_counter > 0) {
        this.$swal.fire({
          icon: 'info',
          title: 'Video downloads are not supported.<br />' + this.video_counter + ' video files within this collection will be excluded.',
          showCancelButton: true,
            confirmButtonText : this.$t('Create.proceed'),
            customClass: {
              confirmButton: 'btn btn-warning mx-1',
              cancelButton: 'btn btn-primary mx-1',
            },
            buttonsStyling: false,
        }).then( (result) => {
          this.video_counter = 0;
          if(result.isConfirmed){
            this.$http.post('networks/collections/download/' + this.collection_slug).then(resp => {
              window.location.href = resp.data;
            });
          }
        });
      } else {
        this.$http.post('networks/collections/download/' + this.collection_slug).then(resp => {
          window.location.href = resp.data;
        });
      }
    },
    deleteCollection() {
      this.confirmModal.show = false;
      this.$http.delete(this.collection.url.delete).then(() => {
        let path = split(this.$route.fullPath, '/');
        if (path[2] == 'collections') {
          this.$router.push('/media');
        } else {
          this.$router.push('/networks/' + path[2] + '/media');
        }
      });
    },
    visitMedia(collection) {
      if (this.$auth.auth) {
        if (collection.permission == 'public' || collection.permission == 'unlisted' || (this.network && this.network.is_mine) || this.$auth.hasRole('super-admin')) {
          this.authorizedUser = true;
        } else {
          if (this.network) {
            if (this.network.public) {
              if (this.network.moderation) {
                // public and moderated network
                if (this.network.industry_membership_expired) {
                  // for user whose membership has expired
                  this.instance = 'showIndustryMembershipExpiredModal';
                  this.showJoinCard = true;
                } else if (this.network.is_in_moderation_queue) {
                  // for users who have applied to join the moderated network
                  if (this.network.join_status != 'REJECTED') {
                    // for users who have applied to join the moderated network (pending status)
                    this.instance = 'showPendingModerationModalFromMedia';
                    this.showJoinCard = true;
                  } else if (this.network.join_status == 'REJECTED') {
                    // for users who have applied to join the moderated network (rejected status)
                    this.instance = 'showRejectedModerationModalFromMedia';
                    this.showJoinCard = true;
                  }
                } else if (this.network.is_in_industry_moderation_queue) {
                  // for industry users who have applied to join the moderated network
                  if (this.network.industry_join_status != 'REJECTED') {
                    // for industry users who have applied to join the moderated network (pending status)
                    this.instance = 'showIndustryPendingModerationModal';
                    this.showJoinCard = true;
                  } else if (this.network.industry_join_status == 'REJECTED') {
                    // for industry users who have applied to join the moderated network (rejected status)
                    this.instance = 'showIndustryRejectedModerationModal';
                    this.showJoinCard = true;
                  }
                } else {
                  // public and non moderated network - for users who haven't applied to join
                  this.instance = 'showModerationModalFromMedia';
                }
              } else {
                // public and non moderated network
                this.instance = 'showPublicJoinModalFromMedia';
                this.showJoinCard = true;
              }
            } else {
              // private network
              this.instance = 'showPrivateModalFromMedia';
              this.showJoinCard = true;
            }
          } else {
            this.authorizedMedia(collection);
          }
        }
      } else {
        // logged out
        if (collection.permission == 'public' || collection.permission == 'unlisted') {
          this.authorizedUser = true;
        } else {
          if (this.network) {
            // collection within network
            this.instance = 'showLoggedOutModal';
            this.showJoinCard = true;
          } else {
            // collection in all media
            this.$bus.emit('show-sign-in', collection.url.view, this.$t('auth.signInMessage.protectedMedia'));
          }
        }
      }
    },
    toggleLike() {
      this.loading = true;
      this.$http.post('networks/collection/' + this.collection.slug + '/toggle-like').then(resp => {
        if (resp.data == 1) {
          this.is_liked = false;
          // umami tracking for unlike action
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`unlike-collection-${this.collection.id}`, {
              collectionSlug: this.collection.slug,
            });
          }
          this.$swal.fire({
            text: this.$t('removed-from-your-liked-collections'),
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          this.loading = false;
        } else {
          this.is_liked = true;
          // umami tracking for like action
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`like-collection-${this.collection.id}`, {
              collectionSlug: this.collection.slug,
            });
          }
          this.$swal.fire({
            text: this.$t('added-to-your-liked-collections'),
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          this.loading = false;
        }
      });
    },
    copyUrl () {
      let urlToCopy = document.querySelector('#url')
      urlToCopy.setAttribute('type', 'text')
      urlToCopy.select()

      document.getElementById("copied").style.display = "inline";
      document.execCommand("copy");
      setTimeout( function() {
          document.getElementById("copied").style.display = "none";
      }, 1000);

      /* unselect the range */
      urlToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
    goToEditForm() {
      if(this.network) {
        this.$router.push({ name: 'network_collection_update', params: { collection_slug: this.collection_slug, network: this.network } });
      } else {
        this.$router.push({ name: 'update-network-collection-page', params: { collection_slug: this.collection_slug } });
      }
    },
    arraysMatch(arr1, arr2) {
      // function to compare two arrays for equality
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    },
    authorizedMedia(media){
      let foundMatch = false;
      for (let i = 0; i < media.networks.length; i++) {
        for (let j = 0; j < this.myNetworks.length; j++) {
          if (this.arraysMatch(media.networks[i], this.myNetworks[j])) {
            // if there's a match, set authorizedUser to true
            foundMatch = true;
            // exit the inner loop
            break;
          }
        }
        if (foundMatch) {
          // exit the outer loop if a match is found
          break;
        }
      }
      if (foundMatch) {
        this.authorizedUser = true;
      } else {
        this.showPrivateCollectionModal = true;
      }
    }
  },
};
</script>
<style>
.swal2-timer-progress-bar {
  background-color: #198754;
}
</style>
